import { For, type JSX, Match, Switch } from 'solid-js';
import { t } from '../../i18n';
import type { JobUsageView, UsageKind } from '../../lib/machine-jobs';

// One job's usage row (#6745, prototype jobRes, `:2169-2179`, machine-card decision 18):
// CPU, Memory ("Mem" on a narrow card) and Disk, each with a 3 px bar for its share of the
// whole machine. Amber is the view's call (`jobUsageView`); a null reading reads "-" with an
// empty bar and "Not reported yet.". A starting job reads "Measuring usage…" instead.

const LABEL: Readonly<Record<UsageKind, string>> = {
  cpu: 'fleet.machines.bar_cpu',
  memory: 'fleet.machines.bar_memory',
  disk: 'fleet.machines.bar_disk',
};

export function JobUsageRow(props: { readonly view: JobUsageView }): JSX.Element {
  return (
    <Switch>
      <Match when={props.view.kind === 'measuring'}>
        <p class="mission-jobs__usage mission-jobs__usage--measuring">
          {t('fleet.machines.job_measuring')}
        </p>
      </Match>
      <Match when={props.view.kind === 'cells' ? props.view : null}>
        {(cells) => (
          <div class="mission-jobs__usage" title={cells().title ?? undefined}>
            <For each={cells().cells}>
              {(cell) => (
                <span
                  class="mission-jobs__cell"
                  data-kind={cell.kind}
                  title={cell.tip ?? undefined}
                >
                  <span class="mission-jobs__cell-key">
                    <span class="mission-jobs__cell-label">
                      {cell.kind === 'memory' ? (
                        <>
                          <span class="mission-jobs__long">{t(LABEL.memory)}</span>
                          <span class="mission-jobs__short">
                            {t('fleet.machines.card_mini_mem')}
                          </span>
                        </>
                      ) : (
                        t(LABEL[cell.kind])
                      )}
                    </span>
                    <span class="mission-jobs__cell-value" data-amber={cell.amber ? '' : undefined}>
                      {cell.value}
                    </span>
                  </span>
                  <span class="mission-jobs__bar" aria-hidden="true">
                    <i
                      class="mission-jobs__fill"
                      data-amber={cell.amber ? '' : undefined}
                      style={{ width: `${cell.fill}%` }}
                    />
                  </span>
                </span>
              )}
            </For>
          </div>
        )}
      </Match>
    </Switch>
  );
}
